import React from "react";

const MLModule = () => {
  return (
    <>
      <style>
        {`
          @keyframes gradientMove {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
            }
            33% {
              transform: translateY(-30px) translateX(15px);
            }
            66% {
              transform: translateY(15px) translateX(-15px);
            }
          }

          @keyframes neuralPulse {
            0%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.2);
            }
          }

          @keyframes dataFlow {
            0% {
              stroke-dashoffset: 1000;
            }
            100% {
              stroke-dashoffset: 0;
            }
          }

          @keyframes rotate3d {
            0% {
              transform: perspective(1200px) rotateY(0deg) rotateX(10deg);
            }
            100% {
              transform: perspective(1200px) rotateY(360deg) rotateX(10deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          @keyframes blink {
            0%, 50%, 100% {
              opacity: 1;
            }
            25%, 75% {
              opacity: 0.4;
            }
          }

          .project-page {
            position: relative;
            background: linear-gradient(-45deg, #000000, #0a0a0a, #1a0a1a, #0a1a2a);
            background-size: 400% 400%;
            animation: gradientMove 15s ease infinite;
            min-height: 100vh;
            padding: 90px 20px;
            color: #fff;
            font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
            overflow: hidden;
          }

          .project-page::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(34, 197, 94, 0.12) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(59, 130, 246, 0.12) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(168, 85, 247, 0.1) 0%, transparent 50%);
            animation: float 20s ease-in-out infinite;
            pointer-events: none;
          }

          .project-page::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              ),
              repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }

          .project-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            z-index: 1;
          }

          .project-badge {
            display: inline-block;
            background: linear-gradient(135deg, #22c55e, #3b82f6);
            padding: 8px 24px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 30px;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .project-title {
            font-size: 52px;
            font-weight: 700;
            margin-bottom: 40px;
            letter-spacing: 1px;
            background: linear-gradient(135deg, #22c55e, #3b82f6, #a855f7, #22c55e);
            background-size: 300% 300%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .hero-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
            margin-bottom: 100px;
          }

          .hero-content {
            padding-right: 20px;
          }

          .hero-text {
            font-size: 18px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .ml-animation-container {
            position: relative;
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
            perspective: 1200px;
          }

          .neural-network {
            position: relative;
            width: 400px;
            height: 400px;
            animation: rotate3d 20s linear infinite;
          }

          .network-layer {
            position: absolute;
            display: flex;
            flex-direction: column;
            gap: 30px;
            justify-content: center;
            height: 100%;
          }

          .layer-input {
            left: 0;
          }

          .layer-hidden {
            left: 50%;
            transform: translateX(-50%);
          }

          .layer-output {
            right: 0;
          }

          .neuron {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: radial-gradient(circle at 30% 30%, #22c55e, #16a34a, #166534);
            box-shadow: 
              0 0 30px rgba(34, 197, 94, 0.6),
              inset 0 0 20px rgba(0, 0, 0, 0.5);
            position: relative;
            animation: neuralPulse 3s ease-in-out infinite;
          }

          .neuron::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.8);
            animation: blink 2s ease-in-out infinite;
          }

          .neuron-1 { animation-delay: 0s; }
          .neuron-2 { animation-delay: 0.3s; }
          .neuron-3 { animation-delay: 0.6s; }
          .neuron-4 { animation-delay: 0.9s; }
          .neuron-5 { animation-delay: 1.2s; }

          .connection-line {
            position: absolute;
            height: 2px;
            background: linear-gradient(90deg, #3b82f6, #22c55e);
            opacity: 0.3;
            transform-origin: left center;
          }

          .brain-container {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 200px;
            height: 200px;
            border: 3px solid rgba(34, 197, 94, 0.4);
            border-radius: 50%;
            animation: pulse 4s ease-in-out infinite;
          }

          .brain-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 80px;
            animation: neuralPulse 3s ease-in-out infinite;
          }

          .data-particles {
            position: absolute;
            width: 10px;
            height: 10px;
            background: #3b82f6;
            border-radius: 50%;
            animation: float 4s ease-in-out infinite;
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.8);
          }

          .particle-1 {
            top: 10%;
            left: 10%;
            animation-delay: 0s;
          }

          .particle-2 {
            top: 20%;
            right: 15%;
            animation-delay: 0.5s;
          }

          .particle-3 {
            bottom: 15%;
            left: 20%;
            animation-delay: 1s;
          }

          .particle-4 {
            bottom: 25%;
            right: 10%;
            animation-delay: 1.5s;
          }

          .glow-ring {
            position: absolute;
            border-radius: 50%;
            border: 2px solid rgba(34, 197, 94, 0.2);
            animation: pulse 4s ease-in-out infinite;
          }

          .ring-1 {
            width: 400px;
            height: 400px;
          }

          .ring-2 {
            width: 500px;
            height: 500px;
            border-color: rgba(59, 130, 246, 0.15);
            animation-delay: 1s;
          }

          .ring-3 {
            width: 600px;
            height: 600px;
            border-color: rgba(168, 85, 247, 0.1);
            animation-delay: 2s;
          }

          .description-section {
            background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
            padding: 60px;
            border-radius: 20px;
            margin-bottom: 40px;
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .description-section:hover {
            transform: translateY(-8px);
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
          }

          .section-title {
            font-size: 32px;
            font-weight: 600;
            margin-bottom: 25px;
            background: linear-gradient(135deg, #22c55e, #3b82f6);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .highlight-box {
            background: linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(59, 130, 246, 0.1));
            border-left: 4px solid #22c55e;
            padding: 25px;
            border-radius: 10px;
            margin: 30px 0;
          }

          .highlight-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            font-style: italic;
          }

          @media (max-width: 968px) {
            .hero-section {
              grid-template-columns: 1fr;
              gap: 40px;
            }

            .project-title {
              font-size: 38px;
            }

            .ml-animation-container {
              height: 400px;
            }

            .description-section {
              padding: 40px;
            }

            .neural-network {
              width: 300px;
              height: 300px;
            }

            .neuron {
              width: 40px;
              height: 40px;
            }
          }
        `}
      </style>

      <section className="project-page">
        <div className="project-container">
          <div className="project-badge">Upcoming Project</div>
          <h1 className="project-title">ML Module</h1>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <p className="hero-text">
                Zyntro Software Solutions proudly presents the ML Module, an advanced Machine Learning platform designed to empower businesses and developers with cutting-edge artificial intelligence capabilities. This comprehensive solution democratizes access to sophisticated machine learning algorithms, enabling organizations of all sizes to harness the power of AI for data analysis, predictive modeling, automation, and intelligent decision-making without requiring deep expertise in data science.
              </p>
              <p className="hero-text">
                Our ML Module provides a unified framework that seamlessly integrates with existing systems, offering pre-trained models, customizable algorithms, and intuitive tools for training, deploying, and managing machine learning workflows. From natural language processing and computer vision to predictive analytics and recommendation systems, our platform covers the full spectrum of modern AI applications, making it the ideal solution for businesses looking to gain competitive advantages through intelligent automation and data-driven insights.
              </p>
            </div>

            <div className="ml-animation-container">
              <div className="glow-ring ring-1"></div>
              <div className="glow-ring ring-2"></div>
              <div className="glow-ring ring-3"></div>
              
              <div className="data-particles particle-1"></div>
              <div className="data-particles particle-2"></div>
              <div className="data-particles particle-3"></div>
              <div className="data-particles particle-4"></div>

              <div className="neural-network">
                <div className="network-layer layer-input">
                  <div className="neuron neuron-1"></div>
                  <div className="neuron neuron-2"></div>
                  <div className="neuron neuron-3"></div>
                  <div className="neuron neuron-4"></div>
                </div>
                
                <div className="network-layer layer-hidden">
                  <div className="neuron neuron-2"></div>
                  <div className="neuron neuron-3"></div>
                  <div className="neuron neuron-4"></div>
                  <div className="neuron neuron-5"></div>
                  <div className="neuron neuron-1"></div>
                </div>
                
                <div className="network-layer layer-output">
                  <div className="neuron neuron-3"></div>
                  <div className="neuron neuron-4"></div>
                  <div className="neuron neuron-5"></div>
                </div>

                <div className="brain-container">
                  <div className="brain-icon">🧠</div>
                </div>
              </div>
            </div>
          </div>

          {/* Description Section 1 */}
          <div className="description-section">
            <h2 className="section-title">Comprehensive ML Capabilities & Architecture</h2>
            <p className="section-text">
              The ML Module is built on a robust, scalable architecture that supports the entire machine learning lifecycle, from data preparation and feature engineering to model training, validation, and deployment. Our platform incorporates state-of-the-art algorithms spanning supervised learning, unsupervised learning, reinforcement learning, and deep learning paradigms. Users can leverage pre-built models for common tasks such as image classification, sentiment analysis, fraud detection, and demand forecasting, or develop custom models tailored to their specific business requirements using our flexible framework.
            </p>
            <p className="section-text">
              At the heart of our system lies an intelligent AutoML engine that automates the complex process of model selection, hyperparameter tuning, and feature optimization. This revolutionary capability enables users without extensive machine learning expertise to develop high-performing models by simply providing their data and defining objectives. The AutoML engine employs advanced techniques including neural architecture search, Bayesian optimization, and ensemble methods to explore vast model spaces efficiently, often discovering solutions that match or exceed those created by experienced data scientists.
            </p>
            <div className="highlight-box">
              <p className="highlight-text">
                "Machine learning should be accessible to everyone, not just data scientists. Our ML Module bridges the gap between sophisticated AI capabilities and practical business applications, enabling organizations to transform raw data into actionable intelligence with unprecedented ease and speed."
              </p>
            </div>
            <p className="section-text">
              The platform's data processing pipeline handles diverse data types including structured databases, unstructured text, images, audio, video, and time-series data. Advanced preprocessing capabilities automatically handle missing values, outlier detection, normalization, and feature scaling. Our feature engineering toolkit includes automated feature generation, dimensionality reduction, and feature selection algorithms that identify the most relevant predictors for your models. Integration with popular data sources such as SQL databases, NoSQL systems, cloud storage, and real-time data streams ensures seamless connectivity with existing infrastructure. The system also supports federated learning, enabling organizations to train models on distributed datasets while maintaining data privacy and security.
            </p>
          </div>

          {/* Description Section 2 */}
          <div className="description-section">
            <h2 className="section-title">Deployment, Monitoring & Enterprise Integration</h2>
            <p className="section-text">
              Deploying machine learning models into production environments has traditionally been a significant challenge, but our ML Module streamlines this process with comprehensive deployment tools and infrastructure. Models can be deployed as REST APIs, batch processing jobs, or embedded directly into applications using our lightweight inference engines. The platform supports multiple deployment targets including on-premises servers, cloud environments, edge devices, and mobile platforms, with automatic optimization for each target architecture to ensure optimal performance and resource utilization.
            </p>
            <p className="section-text">
              Our robust model monitoring and management system provides real-time visibility into model performance, detecting data drift, concept drift, and performance degradation before they impact business outcomes. Automated retraining pipelines can be configured to continuously improve models as new data becomes available, ensuring that predictions remain accurate over time. The platform includes A/B testing capabilities for comparing model versions, gradual rollout mechanisms for safe deployment of updates, and instant rollback options if issues are detected. Comprehensive logging and audit trails provide full transparency into model decisions, essential for regulatory compliance and explainability requirements.
            </p>
            <p className="section-text">
              Enterprise integration capabilities ensure that the ML Module works seamlessly within existing IT ecosystems. The platform provides SDKs and APIs for popular programming languages including Python, Java, JavaScript, and R, enabling developers to incorporate machine learning capabilities into applications using familiar tools. Pre-built connectors for business intelligence platforms, data warehouses, CRM systems, and enterprise resource planning software facilitate rapid integration. Role-based access controls, encryption at rest and in transit, and compliance with industry standards such as GDPR, HIPAA, and SOC 2 ensure that sensitive data and models remain secure.
            </p>
            <p className="section-text">
              The ML Module also includes comprehensive visualization and explanation tools that make model insights accessible to non-technical stakeholders. Interactive dashboards display model performance metrics, feature importance rankings, and prediction distributions. Explainability features such as SHAP values, LIME, and attention visualizations help users understand why models make specific predictions, building trust and enabling informed decision-making. As Zyntro Software Solutions continues to advance this platform, we remain committed to making machine learning a practical, powerful tool for solving real-world business challenges, transforming how organizations leverage their data assets to drive innovation, efficiency, and competitive advantage in an increasingly AI-driven world.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default MLModule;